import { render, staticRenderFns } from "./vehicleprofile.vue?vue&type=template&id=2d1bb484&scoped=true"
import script from "./vehicleprofile.js?vue&type=script&lang=js&external"
export * from "./vehicleprofile.js?vue&type=script&lang=js&external"
import style0 from "./vehicleprofile.vue?vue&type=style&index=0&id=2d1bb484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bb484",
  null
  
)

export default component.exports